window.dbs = window.dbs || {}
dbs.layout = dbs.layout || {}

dbs.layout.Sidebar = function (ptPageWrapper) {
  const page = $(ptPageWrapper)
  const sidebar = page.find('.sidebar-layout .sidebar')
  const sidebarContainer = page.find('.sidebar-layout .sidebar .container')
  const sidebarContent = page.find('.sidebar-layout .sidebar .sidebar-content')

  const showSidebar = function () {
    dbs.utilities.document.disableScroll()
    sidebar.addClass('active')
  }

  const hideSidebar = function () {
    sidebar.removeClass('active')
    dbs.utilities.document.enabledScroll()
    // when the sidebar container has completed hiding, reset the sidebar scroll position to 0
    let transitionDuration = dbs.utilities.getTransitionDurationFromElement(sidebarContainer)
    setTimeout(function () {
      sidebarContent.scrollTop(0)
    }, transitionDuration)
  }

  page.find('.sidebar-layout .sidebar-toggle').click(function () {
    sidebar.hasClass('active') ? hideSidebar() : showSidebar()
  })

  page.find('.sidebar-layout .overlay').click(function () {
    hideSidebar()
  })
}
